import { render, staticRenderFns } from "./SystemConfigAgentBulletin.vue?vue&type=template&id=15ea8032&"
import script from "./SystemConfigAgentBulletin.vue?vue&type=script&lang=js&"
export * from "./SystemConfigAgentBulletin.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigAgentBulletin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports